module.exports = __webpack_public_path__ + "static/media/vmxn.273a4ddb.svg";